import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import Config from '../../../../Config';
import { dwhAbroadAddonsPopup, dwhAbroadAddonsSuccessPage } from '../../CellcomAbroadLobbyBlock/dwhReports'
import { gaClickToOrderAddon, gaTicketPopupAddon } from '../gaReports';

function AbroadAddonComponent(props) {
  const params = {
    channel: props.activeLobbyTab && props.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate',
    param1: props.isJETAuthentication ? 'JET' : 'WEBSITE',
    param2: props.addon.socCode,
    param3: props.selectedAbroadPackage?.isFamilyBonus ? 'בני משפחות' : props.epiStyleInitializationData.businessIndividualLobby ? 'Individual' : '',
    param4: props.userData?.contactNumber,
    param5: props.countriesCode.map(c => c.countryCode).join(','),
    costumerName: props.userData?.firstName + ' ' + props.userData?.lastName,
    idNumber: props.userData?.IDNumber,
    subscriber: props.subscriber,
  }
  String.prototype.isNumberPrice = function () { return /^\d+(\.\d+)?$/.test(this); }

  const openAddonPopup = () => {
    gaClickToOrderAddon();
    gaTicketPopupAddon();
    dwhAbroadAddonsSuccessPage({ message: 'Addons Purchase Button Clicked', status: 'Ongoing', ...params })
    if (!props.addon.isPurchased) {
      props.showPopup({ ...props.addon });
      dwhAbroadAddonsPopup({ message: 'Addon PopUp Displayed', status: 'Ongoing', ...params });
    }
  }


  return (
    <>
      <div className={`addon-block ${props.addon.isPurchased ? 'already-Purchased' : ''}`} >
        <div className='top-content'>
          <Image className="addon-icon" src={Config.epiBaseUrl + props.addon.icon} />
          <div className="addon-text d-block">{props.addon.packageName}</div>
          <div className="description">{props.addon.title}</div>
        </div>
        <div className="bottom-content">
          {props.addon.isPurchased ?
            <>
              <Image src={require('./../images/checkMarkIcon.svg')} />
              <span className="price already-Purchased addon-text"> כבר יש לך </span>
            </>
            :
            <>
              <Image src={require('./../images/plus-icon.svg')} onClick={() => openAddonPopup()} />
              <span className="price addon-text">{props.addon.price.isNumberPrice() && '₪'}{props.addon.price}</span>
            </>}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    isJETAuthentication: state.cellcomAbroad.isJETAuthentication,
    activeLobbyTab: state.cellcomAbroad.activeLobbyTab,
    selectedAbroadPackage: state.cellcomAbroad.selectedAbroadPackage,
    epiStyleInitializationData: state.cellcomAbroad.epiStyleInitializationData,
    userData: state.authentication?.loginData?.userDetails,
    subscriber: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
      ? state.cellcomAbroad.businessIndividualData.selectedAccountNumber
      : state.cellcomAbroad.otpData.otpPhone || state.authentication.loginData.userDetails.contactNumber,
    countriesCode: state.cellcomAbroad.selectedCountries,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadAddonComponent);
